var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.283152 0.562537C0.668221 0.166633 1.30133 0.157849 1.69723 0.542918L10.5 9.10477L19.3028 0.542918C19.6987 0.157849 20.3318 0.166633 20.7168 0.562537C21.1019 0.958441 21.0931 1.59155 20.6972 1.97661L11.9342 10.4998L20.6972 19.0229C21.0931 19.408 21.1019 20.0411 20.7168 20.437C20.3318 20.8329 19.6987 20.8417 19.3028 20.4566L10.5 11.8948L1.69723 20.4566C1.30133 20.8417 0.668221 20.8329 0.283152 20.437C-0.101917 20.0411 -0.093133 19.408 0.302771 19.0229L9.06575 10.4998L0.302771 1.97661C-0.093133 1.59155 -0.101917 0.958441 0.283152 0.562537Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.1584f13b1ae6945460d0f6666a291eaf.svg";
export { ForwardRef as ReactComponent };